import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Login from "@/pages/Login";
import SimpleLogin from "@/pages/simple/SimpleLogin";
import { isSimpleUiPack } from "@/lib/uiPack";
import { rememberedUiPack } from "@/lib/uiPackStorage";

/**
 * Guest login: Simple look if last company was Simple, or ?pack=simple.
 * After auth, company.ui_pack always wins for the shell.
 */
export default function UiPackLogin() {
  const [params] = useSearchParams();
  const useSimple = useMemo(() => {
    const q = params.get("pack");
    if (q === "simple") return true;
    if (q === "classic") return false;
    return isSimpleUiPack(rememberedUiPack());
  }, [params]);

  return useSimple ? <SimpleLogin /> : <Login />;
}
